<template>
  <div class="order-step">
    <next-prev-menu
      :previous="false"
      title="Naar Bezorgen"
      @next-step="$router.push({ name: 'printProductSecuredSADeliver' })"
    ></next-prev-menu>
    <div id="print-specs" class="two-col-res" :class="{ flipped: flipped }">
      <div>
        <div class="card">
          <div id="scroll-view" class="card-default">
            <div class="select-all-container">
              <select-box
                class="select-all"
                :selected="
                  selectedFiles.length === fileList.length &&
                  fileList.length > 0
                "
                @action="selectAll()"
              ></select-box>
              <h3 @click="selectAll()">
                Bestanden
              </h3>
            </div>
            <div id="scroll-list" class="selection-list selectable">
              <p class="error-text" v-show="fileList.length === 0">
                Verzamel uw bestanden in de bol links
              </p>
              <ul id="file-list" class="card-list print-file-list">
                <file-list-item
                  v-for="file in fileList"
                  :file="file"
                  :key="file.fileName"
                  @click.native="selectFile(file, 'single')"
                  @select-box="selectFile(file, 'multi')"
                  @input-select="inputSelect(file)"
                  @set-qt="setQuantity($event)"
                  :selected="selectedFiles.indexOf(file.fileName) > -1"
                ></file-list-item>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="card card-front sub-card">
          <div class="card-default">
            <div class="title-container">
              <h3>Producten</h3>
            </div>
            <div>
              <ul class="product-menu myclearfix">
                <li
                  v-for="product in products"
                  :key="product"
                  class="template-button"
                >
                  <button
                    class="option-button"
                    @click="setProduct(product)"
                    :class="{ active: curProduct.title === product }"
                  >
                    {{ product }}
                  </button>
                </li>
              </ul>
            </div>
            <div class="sub-btn-holder">
              <button
                class="main-button"
                :class="{ active: orderDetails.instruction.length > 0 }"
                @click="flipCard('instructions')"
              >
                Extra instructies voor printshop
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="card card-back sub-card specs-card">
        <div v-if="cardBack === 'specs'" class="card-default">
          <div>
            <div class="title-container">
              <h3>{{ product }}</h3>
              <button
                class="main-button right-btn"
                @click="flipCard('products')"
              >
                Producten
              </button>
            </div>
            <div
              class="product-spec"
              v-for="(spec, index) in productSpecs"
              :key="spec.title"
              :class="[
                spec.align == 'right' ? 'spec-right' : '',
                spec.align == 'left' ? 'spec-left' : ''
              ]"
              :style="{
                clear:
                  index > 0 && productSpecs[index - 1].align === 'right'
                    ? 'both'
                    : ''
              }"
            >
              <slider
                v-if="spec.type === 'slider'"
                :options="spec"
                :active-specs="activeSpecs"
                @set-val="setVal"
              ></slider>
              <option-menu
                v-else-if="spec.type === 'option'"
                :options="spec"
                :active-specs="activeSpecs"
                @set-val="setVal"
              ></option-menu>
            </div>
          </div>
        </div>
        <div v-else-if="cardBack === 'instructions'" class="instructions">
          <div class="title-container">
            <h3>Instructies voor de printshop</h3>
          </div>

          <textarea
            placeholder="Typ hier uw instructies."
            :value="orderDetails.instruction"
            @input="setInstruction($event.target.value)"
            :class="{ 'hide-overflow': cardBack != 'instructions' || !flipped }"
          ></textarea>
          <div class="sub-btn-holder">
            <button class="main-button back" @click="flipCard('products')">
              Terug naar specificaties
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileListItem from './printSpecs/PrintSpecsListItem.vue'
import Slider from './printSpecs/Slider.vue'
import OptionMenu from './printSpecs/OptionMenu.vue'
import NextPrevMenu from '../../../components/NextPrevMenu.vue'

import { mapStores } from 'pinia'
import { useFileListStore } from '@/stores/FileList.store'
import { usePrintOrderStore } from '@/features/printOrder/PrintOrder.store'
import { usePrintProductSecuredSAStore } from '@/features/printProductSecuredSA/PrintProductSecuredSA.store'

export default {
  data() {
    return {
      flipped: false,
      selectedFiles: [],
      product: '',
      productSpecs: [],
      products: [],
      productsList: {},
      cardBack: 'products',
      activeSpecs: {},
      curProduct: {}
    }
  },
  components: {
    FileListItem,
    Slider,
    OptionMenu,
    NextPrevMenu
  },
  methods: {
    flipCard(card) {
      if (card === 'products') {
        this.flipped = false
        setTimeout(() => {
          this.productSpecs = []
          this.product = ''
        }, 500)
      } else {
        this.cardBack = card
        this.flipped = true
      }
    },
    setInstruction(val) {
      this.printProductSecuredSAStore.updateOrderDetails('instruction', val)
      //   updateOrder('instruction', )
    },
    inputSelect(file) {
      if (this.selectedFiles.indexOf(file.fileName) === -1) {
        this.selectFile(file, 'single')
      }
    },

    selectAll() {
      if (this.selectedFiles.length === this.fileList.length) {
        this.selectedFiles = []
      } else {
        this.selectedFiles = []
        this.fileList.forEach((file) => {
          this.selectFile(file, 'multi')
        })
      }
    },
    selectFile(file, type) {
      if (type === 'single') {
        this.selectedFiles = []
      }

      if (this.selectedFiles.indexOf(file.fileName) === -1) {
        this.selectedFiles.push(file.fileName)
        this.flipCard('products')
      } else {
        this.selectedFiles.splice(this.selectedFiles.indexOf(file.fileName), 1)
      }

      if (this.selectedFiles.length === 1) {
        const prod = {
          ...this.fileList.find((file) => {
            return file.fileName === this.selectedFiles[0]
          })
        }
        this.curProduct = prod.productSpecs
      } else {
        this.curProduct = {}
      }
    },
    setProduct(product) {
      if (this.selectedFiles.length < 1) {
        return
      } else {
        let newProduct = {}
        // let productSet = false

        this.product = product
        this.productSpecs = this.productsList[product]

        if (this.curProduct.title === product) {
          newProduct = this.curProduct
          //productSet = true
        } else {
          newProduct.title = product
          this.productSpecs.forEach((spec) => {
            newProduct[spec.title] = spec.default

            if (
              spec.type === 'option' &&
              spec.options[spec.default].submenus &&
              spec.options[spec.default].submenus.length > 0
            ) {
              spec.options[spec.default].submenus.forEach((opt) => {
                newProduct[opt.title] = opt.default
              })
            }
          })
        }
        this.fileListStore.addProduct(this.selectedFiles, newProduct)

        this.activeSpecs = newProduct

        this.flipCard('specs')
      }
    },
    setVal(type, val) {
      this.fileListStore.updateProductSpec(this.selectedFiles, type, val)

      this.activeSpecs[type] = val
    },
    setQuantity(val) {
      this.fileListStore.updateFileSpec(this.selectedFiles, 'quantity', val)
    },
    updateOrder(key, val) {
      this.$emit('update-order', key, val)
    }
  },
  computed: {
    ...mapStores(
      useFileListStore,
      usePrintProductSecuredSAStore,
      usePrintOrderStore
    ),
    orderDetails() {
      return this.printProductSecuredSAStore.orderDetails
    },
    fileList() {
      return this.fileListStore.fileList
    }
  },
  async created() {
    this.productsList = this.printOrderStore.printTemplatesSecure
    this.products = Object.keys(this.productsList)
  }
}
</script>

<style lang="scss" scoped>
.select-all-container {
  display: flex;
  align-items: center;
}
/* .selection-list {
  border-bottom-left-radius: 5px;
  height: 407px;
  margin: 10px -15px -15px -20px;
  overflow-y: auto;
  perspective: 1px;
  overflow-x: hidden;

  ul {
    margin-bottom: 0;
  }
} */
.selection-list {
  border-bottom-left-radius: 5px;
  height: calc(100% - 10px);
  //height: 431px;
  margin: 5px -20px -20px;
  overflow-y: auto;
  perspective: 1px;
  overflow-x: hidden;
  padding-left: 15px;
  padding-top: 0;
  padding-bottom: 5px;

  ul {
    margin-bottom: 0;
  }

  li {
    margin: 5px;
  }
}

.product-menu {
  margin: 0 -6px;

  button {
    margin-bottom: 10px;
  }
}

.product-spec {
  margin-bottom: 16px;
}
.sub-btn-holder {
  margin-top: auto;
  margin-left: -6px;
}

textarea {
  flex-grow: 2;
}

.card-back.specs-card {
  min-height: 100%;
  height: auto;
}

.instructions {
  padding: 25px;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* fix for backface visiblity + textarea scrollbar issue */
.hide-overflow {
  overflow: hidden;
}
.spec-right {
  float: right;
  width: 50%;
}

.spec-left {
  float: left;
  width: 50%;
}

@media only screen and (min-width: 620px) {
  .card.card-back.specs-card {
    width: 300px;
  }
}
</style>
